var __vue_exports__, __vue_options__
var __vue_styles__ = []

/* styles */
__vue_styles__.push(require("!!../../node_modules/weex-vue-loader/lib/style-loader!../../node_modules/weex-vue-loader/lib/style-rewriter?id=data-v-181b460c!../../node_modules/weex-vue-loader/lib/selector?type=styles&index=0!./index.vue")
)

/* script */
__vue_exports__ = require("!!../../node_modules/weex-vue-loader/lib/script-loader!babel-loader!../../node_modules/weex-vue-loader/lib/selector?type=script&index=0!./index.vue")

/* template */
var __vue_template__ = require("!!../../node_modules/weex-vue-loader/lib/template-compiler?id=data-v-181b460c!../../node_modules/weex-vue-loader/lib/selector?type=template&index=0!./index.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.__file = "/Users/tw93/www/Github/incubator-weex-ui/packages/wxc-refresher/index.vue"
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-181b460c"
__vue_options__.style = __vue_options__.style || {}
__vue_styles__.forEach(function (module) {
  for (var name in module) {
    __vue_options__.style[name] = module[name]
  }
})
if (typeof __register_static_styles__ === "function") {
  __register_static_styles__(__vue_options__._scopeId, __vue_styles__)
}

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./packages/wxc-refresher/index.vue
// module id = 94
// module chunks = 0 1